import AudioPlayer from './audioPlayerContainer'

export default AudioPlayer
